import FacebookIcon from '@mui/icons-material/Facebook';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import YouTubeIcon from '@mui/icons-material/YouTube';
import InstagramIcon from '@mui/icons-material/Instagram';
import ArticleIcon from '@mui/icons-material/Article';
import {
  Box,
  Link,
  Stack,
  Typography,
  IconButton,
  Tooltip,
  Avatar,
  Grid,
} from '@mui/material';
import Logo from './Logo';
import { useTheme } from '@emotion/react';
const Footer = () => {
  const theme = useTheme();

  return (
    <Box bgcolor={theme.palette.primary.lighter}>
      <Box maxWidth='1450px' mx='auto'>
        <Stack
          px={{ xl: '130px', lg: '100px', md: '20px', xs: '24px' }}
          pt='83px'
          pb={{ xl: '201px', md: '140px', xs: '100px' }}
          rowGap={10}
        >
          <Stack
            direction={{ md: 'row', xs: 'column' }}
            rowGap={5}
            justifyContent={'space-between'}
            columnGap={6}
          >
            <Stack rowGap={1.5} justifyContent={'flex-start'}>
              <Logo placement='start' hght='54px' />
              <Stack rowGap={'6px'} pl={{ md: '15px', xs: '0px' }}>
                <Typography fontWeight='bold' variant='body1'>
                  Easiest way to go{' '}
                  <Typography
                    fontWeight='bold'
                    variant='body1'
                    color='primary.main'
                    component={'span'}
                  >
                    solar!
                  </Typography>
                </Typography>

                <Typography variant='body2'>
                  Copyright © 2026 VaySolar. Made in India.
                </Typography>
                <Stack direction='row' spacing={1} pb={0.5}>
                  <Tooltip title='Facebook'>
                    <IconButton
                      href='https://www.facebook.com/vaysolar'
                      target='_blank'
                      sx={{
                        color: '#1877F2',
                        '&:hover': { bgcolor: '#e3f2fd' },
                      }}
                    >
                      <FacebookIcon />
                    </IconButton>
                  </Tooltip>

                  <Tooltip title='LinkedIn'>
                    <IconButton
                      href='https://www.linkedin.com/company/vaysolar/'
                      target='_blank'
                      sx={{
                        color: '#0077B5',
                        '&:hover': { bgcolor: '#e1f5fe' },
                      }}
                    >
                      <LinkedInIcon />
                    </IconButton>
                  </Tooltip>

                  <Tooltip title='Blog'>
                    <IconButton
                      href='https://www.vaysolar.com/docs/blog/'
                      target='_blank'
                      sx={{
                        color: '#FF8C00',
                        '&:hover': { bgcolor: '#fff3e0' },
                      }}
                    >
                      <ArticleIcon />
                    </IconButton>
                  </Tooltip>

                  <Tooltip title='YouTube'>
                    <IconButton
                      href='https://www.youtube.com/@vaysolar'
                      target='_blank'
                      sx={{
                        color: '#FF0000',
                        '&:hover': { bgcolor: '#ffebee' },
                      }}
                    >
                      <YouTubeIcon />
                    </IconButton>
                  </Tooltip>

                  <Tooltip title='Instagram'>
                    <IconButton
                      href='https://www.instagram.com/vaysolar/'
                      target='_blank'
                      sx={{
                        color: '#E1306C',
                        '&:hover': { bgcolor: '#fce4ec' },
                      }}
                    >
                      <InstagramIcon />
                    </IconButton>
                  </Tooltip>

                  <Tooltip title='Quora'>
                    <IconButton
                      href='https://www.quora.com/profile/VaySolar-Rooftop-Solar-Made-Simple'
                      target='_blank'
                      sx={{
                        p: 0.5,
                        '&:hover': { bgcolor: '#fbe9e7' },
                      }}
                    >
                      <Avatar
                        src='https://www.quora.com/favicon.ico'
                        alt='Q'
                        sx={{
                          width: 23,
                          height: 23,
                          borderRadius: '50%',
                          // bgcolor: '#B92B27',
                          // fontSize: 16,
                          // fontWeight: 600,
                          // color: 'white',
                        }}
                      />
                    </IconButton>
                  </Tooltip>
                </Stack>
                <Link
                  target='_blank'
                  color='#444746'
                  underline='none'
                  variant='body2'
                  style={{ cursor: 'pointer' }}
                  onClick={() => {
                    window.open(
                      'https://forms.gle/G53URqgNobFJPhQC7',
                      '_blank',
                    );
                  }}
                  sx={{
                    '&:hover': {
                      color: '#000000',
                      textDecoration: 'underline',
                    },
                  }}
                >
                  Help center
                </Link>
              </Stack>
            </Stack>
            <Stack rowGap={'30px'} justifyContent={'flex-start'}>
              <Link
                target='_blank'
                href='https://www.vaysolar.com/docs'
                color='#444746'
                underline='none'
                fontWeight='bold'
                variant='h5'
                sx={{
                  '&:hover': {
                    color: '#000000',
                    textDecoration: 'underline',
                  },
                }}
              >
                Solar research
              </Link>
              <Stack rowGap={'14px'}>
                <Link
                  color='#444746'
                  underline='none'
                  target='_blank'
                  href='https://www.vaysolar.com/docs/research/how-it-works/'
                  sx={{
                    '&:hover': {
                      color: '#000000',
                      textDecoration: 'underline',
                    },
                  }}
                >
                  <Typography variant='body2' target='_blank'>
                    How solar works?
                  </Typography>
                </Link>
                <Link
                  color='#444746'
                  underline='none'
                  target='_blank'
                  href='https://www.vaysolar.com/docs/research/benefits/'
                  sx={{
                    '&:hover': {
                      color: '#000000',
                      textDecoration: 'underline',
                    },
                  }}
                >
                  <Typography variant='body2' target='_blank'>
                    Benefits of solar
                  </Typography>
                </Link>
                <Link
                  color='#444746'
                  underline='none'
                  target='_blank'
                  href='https://www.vaysolar.com/docs/research/cost/'
                  sx={{
                    '&:hover': {
                      color: '#000000',
                      textDecoration: 'underline',
                    },
                  }}
                >
                  <Typography variant='body2' target='_blank'>
                    Rooftop solar prices
                  </Typography>
                </Link>
              </Stack>
            </Stack>
            <Stack rowGap={'30px'} justifyContent={'flex-start'}>
              <Link
                target='_blank'
                color='#444746'
                underline='none'
                fontWeight='bold'
                variant='h5'
                href='https://www.vaysolar.com/docs/buying-guide/'
                sx={{
                  '&:hover': {
                    color: '#000000',
                    textDecoration: 'underline',
                  },
                }}
              >
                Solar buying guide
              </Link>
              <Stack rowGap={'14px'}>
                <Link
                  color='#444746'
                  underline='none'
                  target='_blank'
                  href='https://www.vaysolar.com/docs/buying-guide/is-solar-right/'
                  sx={{
                    '&:hover': {
                      color: '#000000',
                      textDecoration: 'underline',
                    },
                  }}
                >
                  <Typography
                    variant='body2'
                    href='https://www.vaysolar.com/docs/buying-guide/is-solar-right/'
                    target='_blank'
                  >
                    Is solar right for you?
                  </Typography>
                </Link>
                <Link
                  color='#444746'
                  underline='none'
                  target='_blank'
                  href='https://www.vaysolar.com/docs/buying-guide/get-quotes/'
                  sx={{
                    '&:hover': {
                      color: '#000000',
                      textDecoration: 'underline',
                    },
                  }}
                >
                  <Typography
                    variant='body2'
                    href='https://www.vaysolar.com/docs/buying-guide/get-quotes/'
                    target='_blank'
                  >
                    Get quotes & compare quotes
                  </Typography>
                </Link>
                <Link
                  color='#444746'
                  underline='none'
                  target='_blank'
                  href='https://www.vaysolar.com/docs/buying-guide/choose-installer/'
                  sx={{
                    '&:hover': {
                      color: '#000000',
                      textDecoration: 'underline',
                    },
                  }}
                >
                  <Typography
                    variant='body2'
                    href='https://www.vaysolar.com/docs/buying-guide/choose-installer/'
                    target='_blank'
                  >
                    Choosing an installer
                  </Typography>
                </Link>
                <Link
                  color='#444746'
                  underline='none'
                  target='_blank'
                  href='https://www.vaysolar.com/docs/buying-guide/pitfalls/'
                  sx={{
                    '&:hover': {
                      color: '#000000',
                      textDecoration: 'underline',
                    },
                  }}
                >
                  <Typography
                    variant='body2'
                    href='https://www.vaysolar.com/docs/buying-guide/pitfalls/'
                    target='_blank'
                  >
                    Common pitfalls
                  </Typography>
                </Link>
              </Stack>
            </Stack>
          </Stack>
          <Stack
            direction={{ md: 'row', xs: 'column' }}
            rowGap={5}
            columnGap={16}
            pl={{ md: '15px', xs: '0px' }}
          >
            <Stack rowGap={'20px'}>
              <Typography fontWeight='bold' variant='h5' color='#444746'>
                Partner with us
              </Typography>
              <Stack rowGap={'14px'}>
                <Link
                  color='#444746'
                  underline='none'
                  target='_blank'
                  href='https://support.vaysolar.com/hc/en-us/requests/new?ticket_form_id=14570268863260'
                  variant='body2'
                  sx={{
                    '&:hover': {
                      color: '#000000',
                      textDecoration: 'underline',
                    },
                  }}
                >
                  For installers
                </Link>
                <Link
                  color='#444746'
                  underline='none'
                  target='_blank'
                  href='https://support.vaysolar.com/hc/en-us/requests/new?ticket_form_id=14570268863260'
                  variant='body2'
                  sx={{
                    '&:hover': {
                      color: '#000000',
                      textDecoration: 'underline',
                    },
                  }}
                >
                  For solar consultants
                </Link>
              </Stack>
            </Stack>
            <Stack rowGap={'20px'}>
              <Typography fontWeight='bold' variant='h5' color='#444746'>
                Contributions
              </Typography>
              <Stack rowGap={'14px'}>
                <Link
                  target='_blank'
                  color='#444746'
                  underline='none'
                  href='https://forms.gle/9FSpLfeW5eBw2ot39'
                  variant='body2'
                  sx={{
                    '&:hover': {
                      color: '#000000',
                      textDecoration: 'underline',
                    },
                  }}
                >
                  Technology contributions
                </Link>
                <Link
                  target='_blank'
                  color='#444746'
                  underline='none'
                  href='https://forms.gle/9FSpLfeW5eBw2ot39'
                  variant='body2'
                  sx={{
                    '&:hover': {
                      color: '#000000',
                      textDecoration: 'underline',
                    },
                  }}
                >
                  Beta user program
                </Link>
                <Link
                  target='_blank'
                  color='#444746'
                  underline='none'
                  href='https://forms.gle/9FSpLfeW5eBw2ot39'
                  variant='body2'
                  sx={{
                    '&:hover': {
                      color: '#000000',
                      textDecoration: 'underline',
                    },
                  }}
                >
                  Sustainable lifestyle
                </Link>
              </Stack>
            </Stack>
            <Stack rowGap={'20px'}>
              <Typography fontWeight='bold' variant='h5' color='#444746'>
                Coverage across NCR
              </Typography>
              <Stack rowGap={'14px'}>
                <Link
                  target='_blank'
                  color='#444746'
                  underline='none'
                  href='https://www.vaysolar.com/docs/solar-installation/delhi/'
                  variant='body2'
                  sx={{
                    '&:hover': {
                      color: '#000000',
                      textDecoration: 'underline',
                    },
                  }}
                >
                  Solar in Delhi
                </Link>
                <Link
                  target='_blank'
                  color='#444746'
                  underline='none'
                  href='https://www.vaysolar.com/docs/solar-installation/gurgaon/'
                  variant='body2'
                  sx={{
                    '&:hover': {
                      color: '#000000',
                      textDecoration: 'underline',
                    },
                  }}
                >
                  Solar in Gurgaon
                </Link>
                <Link
                  target='_blank'
                  color='#444746'
                  underline='none'
                  href='https://www.vaysolar.com/docs/solar-installation/faridabad/'
                  variant='body2'
                  sx={{
                    '&:hover': {
                      color: '#000000',
                      textDecoration: 'underline',
                    },
                  }}
                >
                  Solar in Faridabad
                </Link>
              </Stack>
            </Stack>
            <Stack
              flex={1}
              justifyContent={'flex-end'}
              alignItems={{ md: 'flex-end' }}
            >
              <Stack direction='row' columnGap={1}>
                <Link
                  target='_blank'
                  color='#444746'
                  underline='none'
                  variant='body2'
                  href='https://www.vaysolar.com/docs/sitemap.xml'
                  sx={{
                    '&:hover': {
                      color: '#000000',
                      textDecoration: 'underline',
                    },
                  }}
                >
                  Sitemap
                </Link>
                {' | '}
                <Link
                  target='_blank'
                  color='#444746'
                  underline='none'
                  variant='body2'
                  href='https://www.vaysolar.com/docs/privacy/'
                  sx={{
                    '&:hover': {
                      color: '#000000',
                      textDecoration: 'underline',
                    },
                  }}
                >
                  Privacy Policy
                </Link>
              </Stack>
            </Stack>
          </Stack>
          <Stack rowGap={'12px'}>
            <Stack
              direction='row'
              alignItems='center'
              justifyContent='space-between'
            >
              <Typography fontWeight='bold' variant='h5' color='#444746'>
                Service coverage in Delhi
              </Typography>
            </Stack>

            <Grid container spacing={1.5}>
              {[
                [
                  'Solar in Janakpuri',
                  'https://www.vaysolar.com/docs/solar-installation/delhi/janakpuri/',
                ],
                [
                  'Solar in Pitampura',
                  'https://www.vaysolar.com/docs/solar-installation/delhi/pitampura/',
                ],
                [
                  'Solar in Paschim Vihar',
                  'https://www.vaysolar.com/docs/solar-installation/delhi/paschim-vihar/',
                ],
                [
                  'Solar in Vasant Kunj',
                  'https://www.vaysolar.com/docs/solar-installation/delhi/vasant-kunj/',
                ],
                [
                  'Solar in Vasant Vihar',
                  'https://www.vaysolar.com/docs/solar-installation/delhi/vasant-vihar/',
                ],
                [
                  'Solar in Hauz Khas',
                  'https://www.vaysolar.com/docs/solar-installation/delhi/hauz-khas/',
                ],
                [
                  'Solar in Greater Kailash',
                  'https://www.vaysolar.com/docs/solar-installation/delhi/greater-kailash/',
                ],
                [
                  'Solar in Kailash Colony',
                  'https://www.vaysolar.com/docs/solar-installation/delhi/kailash-colony/',
                ],
                [
                  'Solar in Model Town',
                  'https://www.vaysolar.com/docs/solar-installation/delhi/model-town/',
                ],
                [
                  'Solar in Tri Nagar',
                  'https://www.vaysolar.com/docs/solar-installation/delhi/tri-nagar/',
                ],
                [
                  'Solar in Tilak Nagar',
                  'https://www.vaysolar.com/docs/solar-installation/delhi/tilak-nagar/',
                ],
                [
                  'Solar in Vikas Puri',
                  'https://www.vaysolar.com/docs/solar-installation/delhi/vikas-puri/',
                ],
                [
                  'Solar on Barakhamba Road',
                  'https://www.vaysolar.com/docs/solar-installation/delhi/barakhamba-road/',
                ],
              ].map((item, idx) => (
                <Grid item xs={12} sm={6} md={4} key={idx}>
                  <Link
                    target='_blank'
                    href={item[1]}
                    color='#444746'
                    underline='none'
                    variant='body2'
                    sx={{
                      '&:hover': {
                        color: '#000',
                        textDecoration: 'underline',
                      },
                    }}
                  >
                    {item[0]}
                  </Link>
                </Grid>
              ))}
            </Grid>
          </Stack>
        </Stack>
      </Box>
    </Box>
  );
};

export default Footer;
